import { MapMarkerVariantIconMarkerType } from '__generated__v2/graphql';
import { VariantIconMarkerComponentProps } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker';
import { VIEvent } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/VIEvent.tsx';
import { VIIcon } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/VIIcon';
import { VIImage } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/VIImage';
import { VIPoint } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/VIPoint';
import styled, { CSSProperties } from 'styled-components';

interface VariantSwitcherProps {
    variantIconMarkerProps: VariantIconMarkerComponentProps;
    style?: CSSProperties;
    className?: string;
}

export const VariantSwitcher = (props: VariantSwitcherProps) => {
    const marker = props.variantIconMarkerProps;

    function canShowImage() {
        if (marker.markerType === MapMarkerVariantIconMarkerType.Image) return true;
        if (marker.markerType === MapMarkerVariantIconMarkerType.Automatic && !marker.eventDate)
            return true;
        if (
            marker.markerType === MapMarkerVariantIconMarkerType.Automatic &&
            marker.eventDate &&
            marker.eventShowImage
        )
            return true;
        return false;
    }

    return (
        <S_VariantSwitcher className={props.className} style={props.style}>
            {marker.markerType === MapMarkerVariantIconMarkerType.Point && (
                <VIPoint
                    color={marker.color}
                    highlighted={marker.highlighted}
                    title={marker.text}
                    size={marker.size}
                    sublabel={marker.sublabel}
                />
            )}
            {marker.markerType === MapMarkerVariantIconMarkerType.Icon && (
                <VIIcon
                    color={marker.color}
                    highlighted={marker.highlighted}
                    title={marker.text}
                    size={marker.size}
                    icon={marker.iconName}
                />
            )}
            {canShowImage() && (
                <VIImage
                    color={marker.color}
                    highlighted={marker.highlighted}
                    title={marker.text}
                    size={marker.size}
                    imageUrl={marker.imageUrl as string}
                    imageShowBg={marker.imageShowBg}
                    imageShowContain={marker.imageShowContain}
                    eventDate={marker.eventDate}
                    sublabel={marker.sublabel}
                />
            )}
            {marker.markerType === MapMarkerVariantIconMarkerType.Automatic &&
                marker.eventDate &&
                !marker.eventShowImage && (
                    <VIEvent
                        color={marker.color}
                        highlighted={marker.highlighted}
                        title={marker.text}
                        size={marker.size}
                        eventDate={marker.eventDate}
                    />
                )}
        </S_VariantSwitcher>
    );
};

const S_VariantSwitcher = styled.div``;
